var React = require('react');

function SnellIconArrowLeft (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".snell-icon-arrow{fill:#fff;}")),React.createElement("g",{"transform":"translate(-17148 -117)","key":1},React.createElement("g",{"transform":"translate(784 110) rotate(180)"},[React.createElement("g",{"transform":"translate(-784 -699)","key":0},React.createElement("path",{"className":"a","d":"M18,0A18,18,0,1,1,0,18,18,18,0,0,1,18,0Z","transform":"translate(303 595)"})),React.createElement("path",{"className":"snell-icon-arrow","d":"M8,0,6.545,1.455l5.506,5.506H0V9.039H12.052L6.545,14.545,8,16l8-8Z","transform":"translate(-471 -94)","key":1})]))]);
}

SnellIconArrowLeft.defaultProps = {"viewBox":"-15919 61 36 36"};

module.exports = SnellIconArrowLeft;

SnellIconArrowLeft.default = SnellIconArrowLeft;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js?name=SnellIconArrowLeft!./src/assets/images/icon_ball_arrow_left.svg
// module id = 827
// module chunks = 1